export default "__VITE_ASSET__CLgk8jAW__"